import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

import Constants from 'constants/Constants';

// -- utils
import AbstractComponent from 'components/AbstractComponent';
import DateUtils from 'PMT/utils/DateUtils';

// -- entities
import OpeningHour from 'PMT/entities/OpeningHour';

// -- views
import { Modal } from 'react-bootstrap';
import DayChooser from '../DayChooser';
import HourChooser from 'PMT/components/form/HourChooser';

class AddOpeningHourModal extends AbstractComponent {

  static defaultProps = {
    defaultOpeningHour: new OpeningHour(),
    defaultDay: Constants.Day.MONDAY
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,

    onHide: PropTypes.func.isRequired,

    // -- params: Number (Day), openingHour (OpeningHour)
    onAddOpeningHourForDay: PropTypes.func.isRequired,

    defaultOpeningHour: PropTypes.instanceOf(OpeningHour),

    defaultDay: PropTypes.number
  };

  state = {
    day: this.props.defaultDay,

    openingHour: this.props.defaultOpeningHour
  };


  // -- events

  onOpeningHourChange = (opening: number) => {
    const openingHour: OpeningHour = this.state.openingHour;
    openingHour.opening = opening;

    this.setState({
      openingHour
    });
  };

  onClosingHourChange = (closing: number) => {
    const openingHour: OpeningHour = this.state.openingHour;
    openingHour.closing = closing;

    this.setState({
      openingHour
    });
  };

  onDayChange = (value: number) => {
    this.setState({
      day: value
    });
  };

  onSubmit = (event) => {
    event.preventDefault();

    const openingHour: OpeningHour = this.state.openingHour;

    // TODO: validation
    if (openingHour.closing - openingHour.opening <= 0) {
      // TODO: display error invalid range.
    } else {
      this.props.onAddOpeningHourForDay(this.state.day, openingHour);
      this.close();
    }
  };

  close = () => {
    this.props.onHide();
  };

  // -- renderers

  renderDayPicker() {
    return (
      <DayChooser
        day={this.state.day}
        onChange={this.onDayChange}
      />
    );
  }

  renderOpeningHour() {
    return (
      <HourChooser
        onChange={this.onOpeningHourChange}
        defaultValue={this.state.openingHour.opening}
      />
    );
  }

  renderClosingHour() {
    return (
      <HourChooser
        onChange={this.onClosingHourChange}
        defaultValue={this.state.openingHour.closing}
        withEndOfDay
      />
    );
  }

  renderBody() {
    return (
      <div>
        <form
          className="form form-horizontal booking_form"
          role="form"
          noValidate
          onSubmit={this.onSubmit}
        >

          <div className="form-group">
            <div className="required col-xs-4 control-label">
              <label>
                {I18n.tr('components.opening_hours.form_modal.day')}
              </label>
            </div>
            <div className="col-xs-6">
              {this.renderDayPicker()}
            </div>
          </div>

          <div className="form-group">
            <div className="required col-xs-4 control-label">
              <label>
                {I18n.tr('components.opening_hours.form_modal.opening')}
              </label>
            </div>
            <div className="col-xs-6">
              {this.renderOpeningHour()}
            </div>
          </div>

          <div className="form-group">
            <div className="required col-xs-4 control-label">
              <label>
                {I18n.tr('components.opening_hours.form_modal.closing')}
              </label>
            </div>
            <div className="col-xs-6">
              {this.renderClosingHour()}
            </div>
          </div>

          <div className="text-center">
            <button
              type="submit"
              className="btn btn-primary"
              onClick={this.onSubmit}
            >
              {I18n.tr('components.opening_hours.form_modal.create')}
            </button>
          </div>

        </form>
      </div>
    );
  }

  render() {
    try {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={this.props.onHide}
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.close}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {I18n.tr('components.opening_hours.form_modal.title')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
    );
  } catch (e) { console.error(e); }
  }

}

export default AddOpeningHourModal;
